import { WelcomeModal } from './welcome-modal';

export { WelcomeModal };
